'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint no-undef: "off" */
/**
 * util工具文件
 */
define('util',[],function () {
  var Util = function () {
    function Util() {
      _classCallCheck(this, Util);
    }

    _createClass(Util, null, [{
      key: 'validateHttp',

      // 验证所有的requirest请求状态
      value: function validateHttp(response) {
        return new Promise(function (resolve, reject) {
          if (response.data.code === 200 && response.data.message === '') {
            resolve(response.data.data);
          } else {
            reject(response.data);
          }
        });
      }

      /**
       * 重定向到指定的url
       * @param url
       */

    }, {
      key: 'redirect',
      value: function redirect(url) {
        window.location.href = url;
      }

      /**
       * 从字符串中提取价格
       * @param {string} priceLabel
       */

    }, {
      key: 'formatPrice',
      value: function formatPrice(priceLabel) {
        var reg = new RegExp(/(\d+,)?\d+[\\.]\d+/ig);
        var arr = reg.exec(priceLabel);
        if (arr !== null) {
          return arr[0];
        }
      }

      /**
       * 将有千分号隔符，处理为number
       * @param {number} price
       */

    }, {
      key: 'formatNumberPrice',
      value: function formatNumberPrice(price) {
        if (typeof price === 'Number') {
          return price;
        }
        price = price.replace(',', '');
        var exp = /([\d\.]+)/.exec(price);
        if (exp.length) {
          return Number(exp[0]);
        }
        return 0;
      }

      /**
       * 防抖函数
       * @param {*} handler
       * @param {*} wait
       * @param {*} content
       */

    }, {
      key: 'debounce',
      value: function debounce(handler, wait) {
        var timeId = null;
        return function () {
          var ctx = this;
          var args = arguments;
          if (timeId) clearTimeout(timeId);
          timeId = setTimeout(function () {
            handler.apply(ctx, args);
          }, wait);
        };
      }

      /**
       * 格式化cart item 数据
       * @param {*} cartItem
       */

    }, {
      key: 'normalizeCartItem',
      value: function normalizeCartItem(cartItem) {
        var map = {};
        cartItem.forEach(function (item) {
          if (!map[item.warehouse]) {
            map[item.warehouse] = [];
          }
          map[item.warehouse].push(item);
        });
        return map;
      }
    }, {
      key: 'isInViewPortOfTwo',
      value: function isInViewPortOfTwo(el) {
        if (!el) return false;
        var viewPortHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        var top = el.getBoundingClientRect() && el.getBoundingClientRect().top;
        return top <= viewPortHeight + 100;
      }
    }, {
      key: 'getURLSearchParams',
      value: function getURLSearchParams() {
        var search = window.location.search;
        if (search) {
          return new URLSearchParams(search.slice(1));
        }

        return new URLSearchParams();
      }
    }, {
      key: 'Logout',
      value: function Logout() {
        window.localStorage && window.localStorage.removeItem('token');
        Util.redirect('/customer/account/logout/');
      }

      /**
       * 获取Token
       * @returns String
       */

    }, {
      key: 'getToken',
      value: function getToken() {
        return window.localStorage && window.localStorage.getItem('token') || '';
      }
    }, {
      key: 'isXparkBrowser',
      value: function isXparkBrowser() {
        return new RegExp('XPark-App').test(navigator.userAgent);
      }
    }, {
      key: 'isH5App',
      value: function isH5App() {
        return new RegExp('h5xparkwb').test(navigator.userAgent);
      }
    }, {
      key: 'getAppUrl',
      value: function getAppUrl(url, target, id) {
        if (this.isXparkBrowser() && url.indexOf('target=') === -1) {
          var symbol = '?';
          if (url.indexOf('?') !== -1) {
            symbol = '&';
          }
          return url + symbol + 'target=' + target + '&id=' + id;
        }
        return url;
      }
    }, {
      key: 'subtractPrice',
      value: function subtractPrice(price, discount) {
        var op = price.replace(',', '');
        var fprice = this.formatNumberPrice(price) - this.formatNumberPrice(discount);
        fprice = fprice.toLocaleString();
        var exp = /([\d\.\,]+)/.exec(price);

        if (exp.length) {
          return price.replace(exp[1], fprice);
        }
        return price;
      }
    }, {
      key: 'getCookie',
      value: function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i].trim();
          if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
      }
    }, {
      key: 'setCookie',
      value: function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + "; " + expires;
      }
    }, {
      key: 'compareValues',
      value: function compareValues(a, b) {
        var comparion = 0;
        if (Number(a.ab_version_percent) > Number(b.ab_version_percent)) {
          comparion = 1;
        } else if (Number(a.ab_version_percent) < Number(b.ab_version_percent)) {
          comparion = -1;
        }
        return comparion;
      }
    }, {
      key: 'getAbVersion',
      value: function getAbVersion(data) {
        if (Util.getCookie('ab_version') !== "") return Util.getCookie('ab_version');
        var sortData = data.sort(Util.compareValues);
        var versionRand = Math.random() * 100;
        var currentRand = 0;
        var currentVersion = 'default';

        for (var i = 0; i < sortData.length; i++) {
          if (versionRand <= Number(sortData[i].ab_version_percent) + currentRand) {
            currentVersion = sortData[i].ab_version_code;
            break;
          } else {
            currentRand += Number(sortData[i].ab_version_percent);
          }
        }
        Util.setCookie("ab_version", currentVersion, 30);
        return currentVersion;
      }

      // 获取定位
      // 检测定位权限

    }, {
      key: 'checkLocationPermission',
      value: function checkLocationPermission() {
        return new Promise(function (resolve, reject) {
          // 浏览器不支持权限API
          if (!('geolocation' in navigator) || !('permissions' in navigator)) {
            resolve('denied'); // 按未授权处理
            return;
          }
          // 执行查询
          navigator.permissions.query({ name: 'geolocation' }).then(function (status) {
            // 返回 granted / denied / prompt
            resolve(status.state);
          }).catch(function (err) {
            resolve('denied'); // 出错默认按未授权处理
          });
        });
      }

      // 获取定位

    }, {
      key: 'getCurrentLocation',
      value: function getCurrentLocation(options) {
        return new Promise(function (resolve, reject) {
          if (!('geolocation' in navigator)) {
            reject(new Error('浏览器不支持 Geolocation API'));
            return;
          }
          // options: { enableHighAccuracy, timeout (ms), maximumAge (ms) }
          navigator.geolocation.getCurrentPosition(function (pos) {
            return resolve(pos);
          }, function (err) {
            return reject(err);
          }, options);
        });
      }

      // 使用谷歌接口获取定位

    }, {
      key: 'getPositionWithGoogle',
      value: function getPositionWithGoogle(apiKey, options) {
        if (!apiKey) apiKey = 'AIzaSyBeazbE0fS9LoTnaqdWXRKsVw86Oa823Ww';
        if (!options) options = {};

        var url = 'https://www.googleapis.com/geolocation/v1/geolocate?key=' + apiKey;
        var requestBody = options;
        requestBody.considerIp = true;

        // 关键：必须 return Promise 出去
        return fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        }).then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              var msg = error.error && error.error.message || 'HTTP ' + response.status;
              throw new Error(msg);
            });
          }
          // 关键：response.json() 必须等待
          return response.json();
        }).then(function (data) {
          console.log('Google 定位原始数据：', data);
          return {
            success: true,
            location: {
              lat: data.location.lat,
              lng: data.location.lng,
              accuracy: data.accuracy
            },
            raw: data
          };
        }).catch(function (error) {
          console.error('Google Geolocation API 错误：', error);
          return {
            success: false,
            error: error.message
          };
        });
      }

      // 计算两个坐标点距离

    }, {
      key: 'calculateDistance',
      value: function calculateDistance(lat1, lon1, lat2, lon2) {
        function deg2rad(degrees) {
          return degrees * (Math.PI / 180);
        }

        var earthRadius = 6371; // 地球平均半径（公里）

        // 转换为弧度
        var radLat1 = deg2rad(lat1);
        var radLon1 = deg2rad(lon1);
        var radLat2 = deg2rad(lat2);
        var radLon2 = deg2rad(lon2);

        // 差值
        var deltaLat = radLat2 - radLat1;
        var deltaLon = radLon2 - radLon1;

        // Haversine 公式
        var a = Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLon / 2), 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return earthRadius * c;
      }

      // 获取当前定位的城市，并切换城市

    }, {
      key: 'getPositionCityName',
      value: function getPositionCityName(position, apiKey) {
        if (!apiKey) apiKey = 'AIzaSyBeazbE0fS9LoTnaqdWXRKsVw86Oa823Ww';
        var url = 'https://geocode.googleapis.com/v4beta/geocode/location/' + position + '?key=' + apiKey;
        return fetch(url).then(function (response) {
          if (!response.ok) {
            return response.json().then(function (error) {
              var msg = error.error && error.error.message || 'HTTP ' + response.status;
              throw new Error(msg);
            });
          }
          return response.json();
        }).then(function (data) {
          var addr = [];
          if (data && data.results) {
            var res = data.results.filter(function (item) {
              return item.granularity === 'ROOFTOP';
            });
            if (res && res[0] && res[0].addressComponents) {
              addr = res[0].addressComponents.filter(function (v) {
                return v.types && v.types[0] && ['locality', 'administrative_area_level_3'].indexOf(v.types[0]) >= 0;
              });
            }
          }
          var city = addr.filter(function (item) {
            return item.types && item.types[0] && item.types[0] === 'locality';
          })[0] || {};
          var area = addr.filter(function (item) {
            return item.types && item.types[0] && item.types[0] === 'administrative_area_level_3';
          })[0] || {};
          var cityList = window.localStorage.getItem('city_list');

          if (cityList) {
            try {
              cityList = JSON.parse(cityList);
            } catch (err) {
              cityList = [];
            }
            if (cityList.length) {
              var hasCity = cityList.filter(function (item) {
                return city.longText && item.name && item.name.toLowerCase() === city.longText.toLowerCase();
              })[0];
              if (hasCity && hasCity.children) {
                var checkChild = hasCity.children.filter(function (item) {
                  return city.longText && item.name.toLowerCase() === city.longText.toLowerCase() || area.longText && item.name.toLowerCase() === area.longText.toLowerCase();
                })[0];
                if (checkChild) {
                  return {
                    success: true,
                    area: hasCity,
                    city: checkChild,
                    raw: data
                  };
                }
              }
            }
          }

          return {
            success: false,
            city: []
          };
        }).catch(function (error) {
          return {
            success: false,
            error: error.error_message || 'ERROR'
          };
        });
      }
    }]);

    return Util;
  }();

  return Util;
});
